import React, { Component } from "react";

class EstablishmentInfoForm extends Component {
  render() {
    return (
      <>
        <div className={this.props.workingModal ? "" : "hide"}>
          <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
            CARGANDO INFORMACIÓN
          </div>
        </div>

        <div className={this.props.workingModal ? "hide" : ""}>
          <fieldset className="col-md-12">
            <legend>DATOS ESTABLECIMIENTO</legend>

            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="razon_social">
                    Razón social: <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="razon_social"
                    value={this.props.establecimiento.razon_social}
                    onChange={this.props.handleEstablecimientoChange}
                    name="razon_social"
                    placeholder="Ingrese razón social"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="razon_social-error"
                  ></div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="cedula_ruc">
                    Cédula RUC: <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="cedula_ruc"
                    onChange={this.props.handleEstablecimientoChange}
                    value={this.props.establecimiento.cedula_ruc}
                    name="cedula_ruc"
                    placeholder="Ingrese cédula RUC"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="cedula_ruc-error"
                  ></div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="form-group">
                  <label htmlFor="direccion">
                    Dirección: <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="direccion"
                    onChange={this.props.handleEstablecimientoChange}
                    value={this.props.establecimiento.direccion}
                    name="direccion"
                    placeholder="Ingrese dirección"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="direccion-error"
                  ></div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="correo_electronico">
                    Correo electrónico: <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="correo_electronico"
                    onChange={this.props.handleEstablecimientoChange}
                    value={this.props.establecimiento.correo_electronico}
                    name="correo_electronico"
                    placeholder="Ingrese correo electrónico"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="correo_electronico-error"
                  ></div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="telefono">
                    Teléfono: <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="telefono"
                    onChange={this.props.handleEstablecimientoChange}
                    value={this.props.establecimiento.telefono}
                    name="telefono"
                    placeholder="Ingrese teléfono"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="telefono-error"
                  ></div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="form-group">
                  <label htmlFor="representante_legal">
                    Representante legal <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="representante_legal"
                    onChange={this.props.handleEstablecimientoChange}
                    value={this.props.establecimiento.representante_legal}
                    name="representante_legal"
                    placeholder="Ingrese representante legal"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="representante_legal-error"
                  ></div>
                </div>
              </div>
            </div>

            <hr />

            <button
              type="button"
              onClick={this.props.handleModalFormCloseBtn}
              className="btn btn-danger pull-left"
            >
              Regresar
            </button>

            <button type="submit" className="btn btn-success pull-right">
              Guardar
            </button>

            {/* </div> */}
          </fieldset>
        </div>
      </>
    );
  }
}

export default EstablishmentInfoForm;
